export default __webpack_public_path__ + "static/media/service_21.c60ebe37.png";